import { render, staticRenderFns } from "./Reward.vue?vue&type=template&id=c3590000&"
import script from "./Reward.vue?vue&type=script&lang=js&"
export * from "./Reward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports